


























































































  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { store, StoreState } from "../../store";
  import VueCsvDownloader from 'vue-csv-downloader';
  import {RotateSquare2} from 'vue-loading-spinner';
  import VueElementLoading from 'vue-element-loading';  
  import { mapState } from "vuex";

  @Component({
      components: {
      VueCsvDownloader,
       RotateSquare2,
       VueElementLoading,  
      },
      computed: {
        ...mapState({
              // 'companyproperties': (state: StoreState) => state.notifyData.company_properties,
              //  notify_siebarstatus: (state: StoreState) => state.notifyData.notify_siebarstatus,
              //  properties: (state: StoreState) => state.notifyData.company_properties,

        })
      },
      
    mounted:function(){
      this.$data.validation_msg=true;
        this.loadTextFromFile();
      },
    })
  export default class BulkImporteamMember extends Vue {
        
    data() {
      return {
        text: "",
        data: [{} ],
        fields: [ 'First Name','Last Name','Company','Work','Extension','Mobile','Address','Email','Customer ID','Contact'],
        user_list: [],
        submitted: false,
        sample:[],
        loading:false,
        succus_msg:'',
        file_name:'',
        validation_msg:false,
        payload:{}  ,
       file_valid:false
      };
    }


    sample(){
      alert('click')
    }



   loadTextFromFile(e) {
    var fileUpload = document.getElementById("fileUpload");
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv|.txt)$/;
    this.$data.file_name=this.$data.succus_msg=''; 
      //  var hj=  regex.test(e.target.value.toLowerCase());
      //  var filetype=files ?  e.target.files[0].type: '' ;
      //   var iscsv= filetype==="text/csv" || filetype=== "application/vnd.ms-excel";
      var filename= this.$data.file_name= e.target.files[0].name;
      var fileExt = filename.split('.').pop();
      var iscsv= fileExt==="csv";
       const files = e.target.files;  
          if(iscsv ) {    
            for (let i = 0, f; f = files[i]; i++) {
                var reader = new FileReader();
                reader.onloadend = function(output){
                  var self = this;  
                  var table = document.createElement("table");
                    var rows = output.target.result.split("\n");
                   var data=rows;
                   rows= data.filter((data) => !data.startsWith(",,,,,,,"));
                    var cells = rows[0].split(",");
                    if(rows.length==1){
                      alert('Uploaded file is empty , Please fill out the fields .');
                       this.$data.file_valid=true;
                      return 
                    // cells[0]=cells[0].replace(/"/g,"");
                    // cells[1]=cells[1].replace(/"/g,"");
                    // cells[2]=cells[2].replace(/"/g,"");
                    // cells[3]=cells[3].replace(/"/g,"");
                    // cells[4]=cells[4].replace(/"/g,"");
                    // cells[5]=cells[5].replace(/"/g,"");
                    // cells[6]=cells[6].replace(/"/g,"");
                    // cells[7]=cells[7].replace(/"/g,"");
                    // cells[8]=cells[8].replace(/"/g,"");
                    }
                    var fields=this.$data.fields;
                     this.$data.file_valid=false;
                    if( (cells[0]!= fields[0]) || (cells[1]!= fields[1]) || (cells[2]!= fields[2])  || (cells[3]!= fields[3]) || (cells[4]!= fields[4]) ||
                       ( cells[5]!= fields[5]) || (cells[6]!= fields[6]) || (cells[7]!= fields[7])  || (cells[8]!= fields[8]) 
                       // (cells[9]!= fields[9])
                      )
                    {  
                      alert('Invalid template file, download the sample template and try again.');
                       this.$data.file_valid=true;
                      return;
                    }
                  
                  var user_list=[]; 
                  debugger
                  for (var i = 1; i < rows.length; i++) 
                  {
                    if(rows[i]!=""){  
                      var cells = rows[i].split(",");
                      // First Name
                      //if(!fname)
                      if(cells[0]=="")
                      {
                        alert("Please enter first name .");
                        this.$data.file_valid=true;
                          return;
                      }
                      // Last Name
                        //if(!lname)
                        if(cells[1]=="")
                      {
                        alert("Please enter  last name ");
                        this.$data.file_valid=true;
                          return;
                      }
                      // {
                      //   //cells[3]== work   cells[5]== mob
                      //   if(cells[3]!="" && cells[5]=="" )
                      //     if(!this.validatePhoneNumber(cells[3])) {
                      //     alert("Please enter a valid Main number");
                      //     this.$data.file_valid=true;
                      //     return;
                      //     }
                      //  }
                      // {  
                      //   //cells[3]== work   cells[5]== mob
                      //   if(cells[5]!="" && cells[3]=="" )
                      //     if(!this.validatePhoneNumber(cells[5])) {
                      //     alert("Please enter a valid Phone number");
                      //     this.$data.file_valid=true;
                      //     return;
                      //     }
                      // }
                      // {
                      //   //cells[3]== work   cells[5]== mob
                      //     if(cells[5]=="" && cells[3]=="" )
                      //     if(!this.validatePhoneNumber(cells[5])) {
                      //     alert("Please enter a valid Phone number");
                      //     return;
                      //     }
                      // }
                       // Test email address
                        if(cells[7]!=""){
                        if(!this.validateEmail(cells[7]))  
                        {
                            alert("Please enter a valid email address.");
                            return;
                        }
                        }
                        user_list.push({
                          firstName        :  cells[0],
                          lastName         :  cells[1],
                          companyName      :  cells[2],
                          main             :  cells[3],
                          extension        :  cells[4],
                          mobile           :  cells[5],
                          addline1         :  cells[6],
                          email            :  cells[7],
                          customerid       :  cells[8],
                          contact          :  cells[9],
                         });
                          this.$data.user_list=user_list;
                         }
                         else{
                            rows.splice(i, 1);  
                         }
                  }
                  return false;
                }.bind(this);
                reader.readAsText(f);
            }
          }
           else {
            alert("Please upload a valid CSV file.");  
        }
    }



    submit_feile() {
       if(this.$data.user_list.length==0)
       {alert('Please upload the file.')}

      if(this.$data.user_list.length>0){
       for (var i = 0; i < this.$data.user_list.length; i++) {
            var Newcontact_data:any= {
                        fname        :  this.$data.user_list[i].firstName,
                        lname        :  this.$data.user_list[i].lastName,
                        coyname      :  this.$data.user_list[i].companyName,
                        number       :  this.$data.user_list[i].main,
                        extension    :  this.$data.user_list[i].extension,
                        mobile       :  this.$data.user_list[i].mobile,  
                        custermerid  :  this.$data.user_list[i].customerid,
                        line1        :  this.$data.user_list[i].addline1,
                        email        :  this.$data.user_list[i].email,
                        private      :  this.$data.user_list[i].contact,
                    } 
               this.$store.dispatch('addCaller', Newcontact_data).then(r => {
               this.$emit('bulkimportevent' , 'refresh');
                    }).catch(() => {
                    });   
         }
        }
        // else {
        //   if(this.$data.file_valid){ 
        //       alert('Invalid template file, download the sample template and try again.');
        //   }
        //   // else{
        //   //       alert('Uploaded file is empty , Please fill out the fields .')
        //   // }
        // }
     }

     clearError(){
      this.$data.file_name=this.$data.succus_msg='';
    }

    validatePhoneNumber(phoneNumber: any) {
            if(!phoneNumber) {
			      	return false;
          }
          if(typeof phoneNumber === "number") {
            phoneNumber = phoneNumber.toString();
          }
          //strip all potential nondigits
                phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
                if(!(/[1-9]{1}[0-9]{9}/.test(phoneNumber)))
                    {
                    this.$data.Number_status=false;
                        return false;
                    }
          //Allow US country code if supplied
          const re = /^1?\d{10}$/;
          if(!re.test(phoneNumber)) {
                    this.$data.Number_status=false;
            return false;
        }
            this.$data.Number_status=true;
			  return true;
    }

    validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
           mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(mob_number.length === 10) {
           mob_number = `+1${mob_number}`;
         }
        else {
            mob_number = `+${mob_number}`;
        }
        return mob_number;
    }

    validateEmail(email: any) {
        //Breakdown of this Regex can be found here:
        //https://www.w3resource.com/javascript/form/email-validation.php
        //Seems to cover most all cases.
         const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;///^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!re.test(email)) {
                this.$data.Email_status=false;
                return false;
            }
        this.$data.Email_status=true;
        return true;
    }
    
    }

